import { render } from "./expense-details.vue?vue&type=template&id=651eb4aa&scoped=true"
import script from "./expense-details.vue?vue&type=script&lang=js"
export * from "./expense-details.vue?vue&type=script&lang=js"

import "./expense-details.vue?vue&type=style&index=0&id=651eb4aa&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-651eb4aa"]])

export default __exports__